import { render, staticRenderFns } from "./RatingFormComponent.vue?vue&type=template&id=07aeedc4&scoped=true"
import script from "./RatingFormComponent.vue?vue&type=script&lang=js"
export * from "./RatingFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RatingFormComponent.vue?vue&type=style&index=0&id=07aeedc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aeedc4",
  null
  
)

export default component.exports